import React from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { StateControl } from 'src/components/enterprise/components/StateControl/StateControl';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface InvoiceContactStateControlProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export function InvoiceContactStateControl({
  name,
  id,
  rules,
}: InvoiceContactStateControlProps): JSX.Element {
  return (
    <StateControl
      label={addAsterisk('State', rules)}
      name={name}
      id={id}
      rules={rules}
    />
  );
}
